import React from 'react';

import COLORS from '../../../constants/colors.constants';

const BrandCaretDownIcon = ({
  className = '',
  width = 10,
  height = 6,
  fill = COLORS.brand,
}) => (
  <svg className={className} width={width} height={height} viewBox="0 0 10 6" fill="none">
    <path d="M9.31542 1.36237C9.52541 1.15238 9.37669 0.793335 9.07972 0.793335L0.667343 0.793334C0.370376 0.793334 0.221653 1.15238 0.431641 1.36237L4.63783 5.56856C4.768 5.69873 4.97906 5.69873 5.10923 5.56856L9.31542 1.36237Z" fill={fill}/>
  </svg>
)

export default BrandCaretDownIcon;
